import { render, staticRenderFns } from "./AdminMessageSmsSection.vue?vue&type=template&id=af1c0a3e&scoped=true"
import script from "./AdminMessageSmsSection.vue?vue&type=script&lang=js"
export * from "./AdminMessageSmsSection.vue?vue&type=script&lang=js"
import style0 from "./AdminMessageSmsSection.vue?vue&type=style&index=0&id=af1c0a3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af1c0a3e",
  null
  
)

export default component.exports